module.exports = __webpack_public_path__ + "img/category-sport-hover.69a3fecd.png";